import React from "react";

export default function Footer() {
    return (
        <footer className="bg-white shadow-inner mt-10 border-t border-gray-200">
            <div className="max-w-6xl mx-auto px-6 py-10 md:px-12">
                <div className="flex flex-col md:flex-row justify-between gap-8">

                    {/* Logo + Name */}
                    <div className="flex items-center gap-3">
                        <img
                            src="/pics/logo-vanila-web.png"
                            alt="Vanilla Beauty Clinic"
                            className="h-10 md:h-12 w-auto"
                        />
                        <h2 className="text-2xl font-bold text-primary-600">Vanilla Beauty Clinic</h2>
                    </div>

                    {/* Working hours */}
                    <div>
                        <h4 className="text-lg font-semibold text-gray-800">Lịch làm việc</h4>
                        <p className="text-gray-600 mt-1">Từ 9:00 – 20:00 mỗi ngày</p>
                        <p className="text-gray-500 text-sm">(Trừ ngày lễ — đặt lịch trước)</p>
                    </div>

                    {/* Contact*/}
                    <div>
                        <h4 className="text-lg font-semibold text-gray-800">CSKH & Tiếp nhận thông tin</h4>
                        <ul className="mt-2 space-y-1 text-gray-600 text-sm">
                            <li><a href="https://www.facebook.com/VienThamMyVanilla" target="_blank" rel="noreferrer" className="text-primary-600 hover:underline">Facebook / Messenger</a></li>
                            <li>Zalo - Hotline: <a href="tel:0899739739" className="text-primary-600 font-medium">0899 739 739</a></li>
                            <li>Email: <a href="mailto:vanilla.tadabiz@gmail.com" className="text-primary-600 font-medium">vanilla.tadabiz@gmail.com</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    );
}
